// extracted by mini-css-extract-plugin
module.exports = {"main-component":"stepNext_main-component__3JuQn"};